angular.module('impactx.shareLink', ['ngRoute']);